function createTextUpAnimation(element, options = {}) {
  const config = {
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px",
    lineDelay: 80,
    animateOnce: true,
    ...options,
  };

  const originalContent = element.innerHTML;
  let hasAnimated = element.dataset.hasAnimated === "true";
  let observer = null;
  let wordElements = [];

  function createLineStructure() {
    element.innerHTML = originalContent;

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim()) {
        textNodes.push(node);
      }
    }

    const allWords = [];
    textNodes.forEach((textNode) => {
      const words = textNode.textContent.split(/(\s+)/);
      const parent = textNode.parentNode;
      const fragment = document.createDocumentFragment();

      words.forEach((word) => {
        if (word.trim()) {
          const mask = document.createElement("span");
          mask.className = "line-mask";

          const span = document.createElement("span");
          span.className = "word-content";
          span.textContent = word;

          mask.appendChild(span);
          fragment.appendChild(mask);
          allWords.push(span);
        } else if (word) {
          fragment.appendChild(document.createTextNode(word));
        }
      });

      parent.replaceChild(fragment, textNode);
    });

    requestAnimationFrame(() => {
      calculateLines(allWords);
    });
  }

  function calculateLines(allWords) {
    const lines = [];
    let currentLine = [];
    let currentBaseline = null;

    allWords.forEach((wordSpan) => {
      const rect = wordSpan.getBoundingClientRect();
      const wordTop = Math.round(rect.top);

      if (currentBaseline === null || Math.abs(wordTop - currentBaseline) > 3) {
        if (currentLine.length > 0) {
          lines.push([...currentLine]);
        }
        currentLine = [wordSpan];
        currentBaseline = wordTop;
      } else {
        currentLine.push(wordSpan);
      }
    });

    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    lines.forEach((lineWords, lineIndex) => {
      lineWords.forEach((wordSpan) => {
        wordSpan.style.transitionDelay = `${
          lineIndex * config.lineDelay
        }ms`;
      });
    });

    wordElements = allWords;
  }

  function setupIntersectionObserver() {
    const rect = element.getBoundingClientRect();
    const isInitiallyVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (isInitiallyVisible && !hasAnimated) {
      slideIn();
      hasAnimated = true;
      element.dataset.hasAnimated = "true";
      return; 
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            slideIn();
            if (config.animateOnce) {
              hasAnimated = true;
              element.dataset.hasAnimated = "true";
              observer.unobserve(element);
            }
          }
        });
      },
      {
        threshold: config.threshold,
        rootMargin: config.rootMargin,
      }
    );

    observer.observe(element);
  }

  function slideIn() {
    if (element.dataset.hasAnimated === "true") return;
    element.classList.add("slide-in");
    element.dataset.hasAnimated = "true";
  }

  function slideOut() {
    element.classList.remove("slide-in");
    element.removeAttribute("data-has-animated");
  }

  function toggle() {
    return element.classList.contains("slide-in") ? slideOut() : slideIn();
  }

  function destroy() {
    if (observer) {
      observer.disconnect();
    }
    element.innerHTML = originalContent;
    element.classList.remove("text-processed", "slide-in");
    element.removeAttribute("data-has-animated");
  }

  function init() {
    if (hasAnimated && config.animateOnce) return;

    createLineStructure();
    element.classList.add("text-processed");

    setTimeout(() => {
      setupIntersectionObserver();
    }, 50);
  }

  init();

  return {
    slideIn,
    slideOut,
    toggle,
    destroy
  };
}

function initializeTextUp() {
  const elements = document.querySelectorAll(
    ".text-up:not([data-text-up-initialized])"
  );

  elements.forEach((element) => {
    if (element.dataset.hasAnimated === "true") {
      element.setAttribute("data-text-up-initialized", "true");
      return;
    }

    element.setAttribute("data-text-up-initialized", "true");
    createTextUpAnimation(element);
  });
}

let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    document
      .querySelectorAll(".text-up[data-text-up-initialized]")
      .forEach((element) => {
        if (element.dataset.hasAnimated !== "true") {
          element.removeAttribute("data-text-up-initialized");
          element.classList.remove("text-processed", "slide-in");
        }
      });

    setTimeout(initializeTextUp, 100);
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initializeTextUp, 100);
});

window.createTextUpAnimation = createTextUpAnimation;
window.initializeTextUp = initializeTextUp;
